import template from './eredmeny.pug';
import 'angular-scroll';

const MODULE_NAME = 'eredmeny';
class EredmenyController {
	constructor() {
		'ngInject';
	}

	$onChanges(changeObject) {
		if (changeObject.eredmenyModel && changeObject.eredmenyModel.currentValue) {
			this.eredmeny = angular.copy(this.eredmenyModel);
		}
	}
}

export default angular.module(MODULE_NAME, [])
	.component(MODULE_NAME, {
		controller: EredmenyController,
		template: template(),
		bindings: {
			eredmenyModel: '<'
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/gazdalkodasikalkulator/eredmeny/eredmeny.js